import { withInstall } from '@zoryn/utils'
import Drawer from './src/drawer.vue'

import type { SFCWithInstall } from '@zoryn/utils'

export const ZDrawer: SFCWithInstall<typeof Drawer> = withInstall(Drawer)
export default ZDrawer

export * from './src/drawer'
